<div class="bgimage ">
    <div class="row">
    <div class="col-md-2">
    <label for="deviceSelect" class="dropdown-label">Choose a device:</label>
    </div>
    <div class="col-md-2">
    <select id="deviceSelect" (change)="getDeviceData(selectedDevice)" [(ngModel)]="selectedDevice" class="dropdown-select">
      <option value="" disabled selected>-- Select a device --</option>
      <option *ngFor="let device of deviceList" [value]="device.deviceid">
        {{ device.deviceid }}
      </option>
    </select>
    </div>
    </div>
    
    <div style="top: 1%;" class="row">
        <div class="col-md-6" style="padding-right: 0px;" >
            <mat-card style="margin: 1%;height:25vh;background-color: rgba(0, 0, 0, 0.5); border: 2px solid rgba(255, 75, 75, 0.5);">
                <mat-card-header style="margin: 0px;background-color: red ;padding-top: 0px; padding-right: 0px;">
                    <b style="color: #FFFFFF;">GEORG MACHINE STATUS</b> 
                </mat-card-header>
                <mat-card-content style="color: #FFFFFF;">
                    <div>
                        <h1 class="wave-text"  style="margin-left: 10%;margin-top:2%;font-weight:bolder;font-size: 9vh;" [ngStyle]="{'color':status == 'working'?'#32CD32':status == 'maintenance'?'orange':status=='fault'?'red':status=='quality'?'yellow':status=='setup'?'blue':'white'}" >{{status.toString() | uppercase }}</h1>
                    </div>
                    <div class="row" style="opacity: 0.5;margin-left: 2%;margin-bottom: 2%;margin-top: 4%;font-size: 2.5vh;">
                        <div class="col-md-3">
                            {{statusArray[0]}}
                        </div>
                        <div class="col-md-3">
                            {{statusArray[1]}}
                        </div>
                        <div class="col-md-2">
                            {{statusArray[2]}}
                        </div>
                        <div class="col-md-2">
                            {{statusArray[3]}}
                        </div>
                        <div class="col-md-2">
                            {{statusArray[4]}}
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <!--<div class="col-md-4" style="padding:2px">
            <mat-card style="height:25vh;background-color: rgba(0, 0, 0, 0.3); border: 2px solid rgba(255, 75, 75, 0.5);">
                <mat-card-header style="margin: 0px;background-color: red ;padding-top: 0px; padding-right: 0px;">
                    <b style="color: #FFFFFF;">TOTAL OPERATIONAL TIME</b> 
                </mat-card-header>
                <mat-card-content style="color: #FFFFFF;">
                    <link href="https://fonts.googleapis.com/css2?family=Orbitron:wght@500&display=swap" rel="stylesheet">
                    <div style="margin-top:2%;margin-left: 1%;height:19vh" class="digital-watch">
                        <div style="height:14vh" class="time ">
                          <span >{{operationalHour}}</span>:<span>{{operationalMinute}}</span>:<span>{{operationalSeconds}}</span>
                        </div>
                        <span style="font-size:2vh">Hour</span>&nbsp;&nbsp;:<span style="font-size:2vh">&nbsp;&nbsp;Minute</span>&nbsp;&nbsp;:&nbsp;&nbsp;<span style="font-size:2vh">Seconds</span>
                      </div>
                </mat-card-content>
            </mat-card>
        </div>-->
        <div class="col-md-6">
            <mat-card style="height:25vh;background-color: rgba(0, 0, 0, 0.3); border: 2px solid rgba(255, 75, 75, 0.5);">
                <mat-card-header style="margin: 0px;background-color: red ;padding-top: 0px; padding-right: 0px;justify-content: space-between;">
                    <b style="color: #FFFFFF;">MACHINE TOTAL UTILIZATION</b> <!-- <div style="padding-right:2%;"><i (click)="openPopup('totalUtilization')" class="fa fa-expand"></i></div>-->
                </mat-card-header>
                <mat-card-content style="color: #FFFFFF;">
                    <div style="height:23vh" id="chart"></div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row">
        <!--<div class="col-md-8" style="padding:2px" >
            <mat-card style="margin-left: 2%;height:27vh;background-color: rgba(0, 0, 0, 0.2); border: 2px solid rgba(255, 75, 75, 0.5);">
                <mat-card-header style="margin: 0px;background-color: red ;padding-top: 0px; padding-right: 0px;justify-content: space-between;">
                    <b style="color: #FFFFFF;">RATE</b> <div style="padding-right:2%;"><i (click)="openPopup('workingDuration')" class="fa fa-expand"></i></div>
                </mat-card-header>
                <mat-card-content style="color: #FFFFFF;">
                    <div style="height:25vh;" id="workingChart"></div>
                </mat-card-content>
            </mat-card>
            
        </div>-->
        <div class="col-md-8" style="padding:2px">
            <mat-card style="margin-left: 2%;background-color: rgba(0, 0, 0, 0.2); border: 2px solid rgba(255, 75, 75, 0.5);">
                <mat-card-header style="margin: 0px;background-color: red ;padding-top: 0px; padding-right: 0px;justify-content: space-between;">
                    <div style="float: right;"><b style="color: #FFFFFF;">Report</b> </div> <div style="padding-right:2%;"><i (click)="openPopup('report')" class="fa fa-expand"></i></div>
                </mat-card-header>
                <mat-card-content style="color: white;height:54.5vh;overflow:auto;">
                    <div style="display: flex; flex-wrap: wrap; gap: 16px;">
                      <div style="flex: 1; min-width: 200px;background-color: rgba(255, 255, 255, 0.529);">
                        <mat-label>Duration</mat-label>
                        <mat-select [(value)]="timeFilter">
                          <mat-option *ngFor="let time of timeOptions" [value]="time" (click)='filters("report",time)'>
                            {{time}}
                          </mat-option>
                        </mat-select>
                      </div>
                      <div style="flex: 1; min-width: 200px; display: flex; justify-content: flex-end; align-items: center;">
                        <button style="margin-left: 2%;" mat-button (click)="exporter.exportTable('xlsx',{fileName:'Machine_Report'})">
                          download IN <img src="../../assets/images/icons8-microsoft-excel-30.png">
                        </button>
                      </div>
                    </div>
                    <table mat-table matTableExporter [dataSource]="dataSource" #exporter="matTableExporter" matSort class="example-container mat-elevation-z8" style=" width: 100%;background-color: rgba(0, 0, 0, 0.2); border: 2px solid rgba(255,  75, 75, 0.5);" >
                        <div *ngFor="let col of heading">
                      <ng-container  [matColumnDef]="col">
                        <div *ngIf="col"  >
                            <th mat-header-cell style="height:1vh" *matHeaderCellDef mat-sort-header style=" background-color:rgba(79, 67, 46, 0.76); color: rgb(0, 214, 132);font-size: 1.7vh;position: sticky;z-index: 2;"><b>{{col | uppercase}} </b></th>
                        </div>
                          <div *ngIf="col">
                            <td mat-cell style="color: #FFFFFF;font-size: 1.7vh;" *matCellDef="let element">
                                <ng-container >
                                    {{ element[col] }}
                                </ng-container> 
                            </td>
                          </div>
                        </ng-container>
                      </div>
                        <tr mat-header-row *matHeaderRowDef="heading"></tr>
                        <tr mat-row *matRowDef="let row; columns: heading;"></tr>
                      </table>
                      <mat-paginator #paginator [pageSizeOptions]="[7, 14, 21]" showFirstLastButtons></mat-paginator>
                </mat-card-content>
            </mat-card> 
           
        </div>
        
        <div class="col-md-4" style="padding:2px">
            <div>
            <mat-card style="margin-right: 2%;height:27vh;background-color: rgba(0, 0, 0, 0.2); border: 2px solid rgba(255, 75, 75, 0.5);">
                <mat-card-header style="margin: 0px;background-color: red ;padding-top: 0px; padding-right: 0px;">
                    <b style="color: #FFFFFF;">Operational Efficiency Score(%)</b> 
                </mat-card-header>
                <mat-card-content style="color: #FFFFFF;">
                    <div class="row">
                        <div class="col-md-5" >
                            <div style="margin-left: 6%;margin-top: 8%;font-size: 3vh;text-align: center;">
                               <span style="color: #32CD32;"> <b>UTILIZATION : {{utilization}}%</b> </span><br><span style="color: #dcdcdc;"><b> DOWNTIME : {{downtimeRate}}%</b></span>
                            </div>
                        </div>
                        <div class="col-md-7" style="padding: 0px;">
                            <div style="height:25vh;" id="operatoinalEfficiency"></div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
            </div>
            <div style="padding:2px">
                <mat-card style="margin-right: 2%;height:31vh;background-color: rgba(0, 0, 0, 0.2); border: 2px solid rgba(255, 75, 75, 0.5);">
                    <mat-card-header style="margin: 0px;background-color: red ;padding-top: 0px; padding-right: 0px;">
                        <b style="color: #FFFFFF;">OVERALL TIME IN(%)</b> 
                    </mat-card-header>
                    <mat-card-content style="color: #FFFFFF;">
                        <div class="row">
                            <div class="col-md-4" >
                                <div style="margin-left: 6%;margin-top: 8%;font-size: 3vh;text-align: center;">
                                   <span style="color: #32CD32;"> <b>WORKING <br> {{workingPercentage}}%</b> </span>
                                </div>
                            </div>
                            <div class="col-md-4" style="padding: 0px;">
                                <div style="margin-top: 8%;font-size: 3vh;text-align: center;">
                                    <span style="color: #6d6dff;"> <b>SETUP <br> {{setupPercentage}}%</b> </span>
                                 </div> 
                            </div>
                            <div class="col-md-4" style="padding: 0px;">
                                <div style="margin-top: 8%;font-size: 3vh;text-align: center;">
                                    <span style="color: #ffdf80;"> <b>QUALITY <br> {{qualityPercentage}}%</b> </span>
                                 </div> 
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4" >
                                <div style="margin-left: 6%;margin-top: 12%;font-size: 3vh;text-align: center;">
                                   <span style="color: #FFA500;"> <b>MAINTENANCE <br> {{maintenancePercentage}}%</b> </span>
                                </div>
                            </div>
                            <div class="col-md-4" style="padding: 0px;">
                                <div style="margin-top: 12%;font-size: 3vh;text-align: center;">
                                    <span style="color: #dcdcdc;"> <b>OFF <br> {{offPercentage}}%</b> </span>
                                 </div> 
                            </div>
                            <div class="col-md-4" style="padding: 0px;">
                                <div style="margin-top: 12%;font-size: 3vh;text-align: center;">
                                    <span style="color: #FF0000;"> <b>FAULT <br> {{faultPercentage}}%</b> </span>
                                 </div> 
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
    
            </div>
        </div>
    </div>
    <div class="row">
       <!-- <div class="col-md-4" >
            <mat-card style="height:33vh;background-color: rgba(0, 0, 0, 0.3); border: 2px solid rgba(255, 75, 75, 0.5);">
                <mat-card-header style="margin: 0px;background-color: red ;padding-top: 0px; padding-right: 0px;">
                    <b style="color: #FFFFFF;">TODAY`S OPERATIONAL TIME</b> 
                </mat-card-header>
                <mat-card-content style="color: #FFFFFF;">
                    <link href="https://fonts.googleapis.com/css2?family=Orbitron:wght@500&display=swap" rel="stylesheet">
                    <div style="margin-top:2%;margin-left: 1%;height:26vh" class="digital-watch">
                        <div style="height:20vh" class="time ">
                          <span >{{todaysoperationalHour}}</span>:<span>{{todaysoperationalMinute}}</span>:<span>{{todaysoperationalSeconds}}</span>
                        </div>
                        <span style="font-size:2vh">Hour</span>&nbsp;&nbsp;:<span style="font-size:2vh">&nbsp;&nbsp;Minute</span>&nbsp;&nbsp;:&nbsp;&nbsp;<span style="font-size:2vh">Seconds</span>
                      </div>
                </mat-card-content>
            </mat-card>
            
        </div>-->
        
       
    </div>
    <ng-template #dialogTemplate >
        <div style="background-color: transparent;">
        <mat-card *ngIf="isReport">
          <mat-card-content>
            <div style="display: flex; flex-wrap: wrap; gap: 16px;">
                <div style="flex: 1; min-width: 200px;">
                  <mat-label>Duration</mat-label>
                  <mat-select [(value)]="timeFilter">
                    <mat-option *ngFor="let time of timeOptions" [value]="time" (click)='filters("report",time)'>
                      {{time}}
                    </mat-option>
                  </mat-select>
                </div>
                <div style="flex: 1; min-width: 200px; display: flex; justify-content: flex-end; align-items: center;">
                  <button style="margin-left: 2%;" mat-button (click)="exporter.exportTable('xlsx',{fileName:'Machine_Report'})">
                    download IN <img src="../../assets/images/icons8-microsoft-excel-30.png">
                  </button>
                </div>
              </div>
            <table  mat-table matTableExporter [dataSource]="dialogDataSource" #exporter="matTableExporter" matSort class="example-container mat-elevation-z8" style=" width: 100%;" >
                <div *ngFor="let col of heading">

              <ng-container  [matColumnDef]="col">
                <div *ngIf="col" style="height:1vh" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style=" background-color:wheat; color: black;position: sticky;z-index:3"> {{col}} </th>
                </div>
                  <div *ngIf="col">
                    <td mat-cell *matCellDef="let element">
                        <ng-container >
                            {{ element[col] }} 
                        </ng-container> 
                    </td>
                  </div>
                </ng-container>
              </div>
                <tr mat-header-row *matHeaderRowDef="heading"></tr>
                <tr mat-row *matRowDef="let row; columns: heading;"></tr>
              </table>
          </mat-card-content>
          
        </mat-card>
        <mat-card *ngIf="isTotalUtilization" style="height:60vh;background-color: rgba(0, 0, 0, 0.5); border: 2px solid rgba(255, 75, 75, 0.5);">
            <mat-card-header style="margin: 0px;background-color: red ;padding-top: 0px; padding-right: 0px;justify-content: space-between;">
                <b style="color: #FFFFFF;">MACHINE TOTAL UTILIZATION</b> <div style="padding-right:2%;"></div>
            </mat-card-header>
            <mat-card-content style="color: #FFFFFF;">
                <div style="height:57vh" id="utilizationChart"></div>
            </mat-card-content>
        </mat-card>
        <mat-card *ngIf="isWorkingDuration" style="margin-left: 2%;height:60vh;">
            <mat-card-header style="margin: 0px;background-color: red ;padding-top: 0px; padding-right: 0px;justify-content: space-between;">
                <b style="color: #FFFFFF;">Working Duration</b> <div style="padding-right:2%;"></div>
               <div style="width: 20%;">
                <mat-label>Duration</mat-label>
                <mat-select [(value)]="workingtimeFilter">
                  <mat-option *ngFor="let time of timeOptions" [value]="time" (click)="filters('working',time)">
                    {{time}}
                  </mat-option>
                </mat-select>
                </div>
            </mat-card-header>
           
            <mat-card-content style="color: #FFFFFF;">
                <div style="height:57vh;" id="workingChart1"></div>
            </mat-card-content>
        </mat-card>
        </div>
      </ng-template>
</div>